// extracted by mini-css-extract-plugin
export default {"btnAction":"Repository_btnAction__EmIXR","title":"Repository_title__FkMIa"};